import React from 'react';
import { Stack, Breadcrumbs as BreadcrumbsContainer } from '@mui/material';
import type { BreadCrumb as BreadCrumbTaxonomy } from 'types/breadCrumbs';
import type { BreadCrumb as BreadCrumbGeoMapHeader } from 'types/locationView';
import WavetrakLink from '../WavetrakLink';
import styles from './Breadcrumbs.module.scss';

interface Props {
  breadcrumbs: BreadCrumbTaxonomy[] | BreadCrumbGeoMapHeader[];
  baseUrl?: string;
  className?: string;
}

const Breadcrumbs: React.FC<Props> = ({ baseUrl = '', breadcrumbs, className }) => (
  <Stack direction="row" width="100%" py={className ? 0 : 6} className={styles.wrapper}>
    <BreadcrumbsContainer
      separator={className ? '/' : '›'}
      aria-label="breadcrumb"
      className={className}
    >
      {breadcrumbs?.map((breadcrumb) => (
        <WavetrakLink
          data-testid="breadcrumb"
          className={styles.breadCrumb}
          key={breadcrumb.name}
          href={baseUrl ? `${baseUrl}${breadcrumb.url}` : (breadcrumb as BreadCrumbTaxonomy).href}
        >
          {breadcrumb.name}
        </WavetrakLink>
      ))}
    </BreadcrumbsContainer>
  </Stack>
);

export default Breadcrumbs;
